import { Button } from '@/modules/shared/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/modules/shared/components/ui/dialog'

import { ORDER_STATUS } from '../../constants/order-status.constant'

export function OrderStatusLegendComponent() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 px-2 text-xs font-normal text-muted-foreground"
        >
          Mostrar legendas
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[80dvh] w-[calc(100%-2rem)] max-w-sm overflow-y-auto rounded-lg">
        <DialogHeader>
          <DialogTitle>Legendas dos pedidos</DialogTitle>
          <DialogDescription>Ícones e siglas dos status dos pedidos.</DialogDescription>
        </DialogHeader>
        <ul className="divide-y">
          {Object.values(ORDER_STATUS).map((status) => (
            <li key={status.sigla} className="flex items-center gap-3 py-2 text-sm">
              <status.icon size={18} color={status.color} className="shrink-0" aria-hidden="true" />
              <span>
                <span className="font-medium">{status.sigla}</span> - {status.label}
              </span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
